import { all, fork } from 'redux-saga/effects'

import app from './app'
import authManage from './authManage'
import dataCenter from './dataCenter'
import userManage from './userManage'

export default function* rootSaga() {
  yield all([fork(app), fork(authManage), fork(dataCenter), fork(userManage)])
}
